import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { saveSingle } from "../../services/vehicleService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Table } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import { Link } from "react-router-dom";
import { getAll } from "../../services/visaService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class VehicleForm extends Form {
  state = {
    expiry_duration_options: [
      { id: "", name: "Select option" },
      { id: "monthly", name: "Monthly Plate No" },
      { id: "monthly-installment", name: "Monthly Installment" },
      { id: "yearly", name: "Yearly" },
    ],
    expiryDate: new Date(),
    data: {
      visa_id: "",
      name: "",
      mobile: "",
      cost: "",
      plat_number: "",
      ref_name: "",
      ref_mobile: "",
      expiry_duration_options: "",
      emirates_id: "",
    },
    visas: [],
    errors: {},
  };

  schema = {
    id: Joi.string(),
    plat_number: Joi.string().required().label("Plate Number"),
    visa_id: Joi.number().allow("").label("Visa Account"),
    name: Joi.string().allow("").label("Name"),
    mobile: Joi.string().allow("").label("Mobile"),
    ref_name: Joi.string().label("Reference name"),
    ref_mobile: Joi.string().label("Reference mobile"),
    cost: Joi.number().required().label("Cost"),
    expiry_duration_options: Joi.string().required().label("Renewal Duration"),
    emirates_id: Joi.allow("").label("Emirates Id"),
  };

  handleChangeExpiry = (date) => {
    this.setState({
      expiryDate: date,
    });
  };

  async componentDidMount() {
    this.setState({ blocking: true });
    const { data: visasAccounts } = await getAll();
    const visas = [{ id: "", name: "Select" }, ...visasAccounts];

    this.setState({ visas, blocking: false });
  }

  doSubmit = async () => {
    try {
      this.setState({ blocking: true });

      let formData = new FormData();
      formData.append("visa_id", this.state.data.visa_id);
      formData.append("name", this.state.data.name);
      formData.append("mobile", this.state.data.mobile);
      formData.append("ref_name", this.state.data.ref_name);
      formData.append("ref_mobile", this.state.data.ref_mobile);
      formData.append("cost", this.state.data.cost);
      formData.append("plat_number", this.state.data.plat_number);
      formData.append(
        "expiry_duration_options",
        this.state.data.expiry_duration_options
      );
      formData.append("emirates_id", this.state.data.emirates_id);

      var event = new Date(this.state.expiryDate);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);
      formData.append("expiry_date", date);

      await saveSingle(formData);
      toast.success("Account has been added successfully.");
      this.setState({ blocking: false });
      this.props.history.push("/vehicles-accounts");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.plat_number)
          errors.plat_number = ex.response.data.errors.plat_number;

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        if (ex.response.data.errors.mobile)
          errors.mobile = ex.response.data.errors.mobile;

        if (ex.response.data.errors.cost)
          errors.cost = ex.response.data.errors.cost;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/vehicles.png";
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Add vehicle account</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/vehicles-accounts")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Add vehicle account</h3>
              <p>Provide the information below to add the account.</p>
              {this.renderInput("plat_number", "Plate Number", "text")}
              {this.renderSelect(
                "visa_id",
                "Select visa account (optional)",
                this.state.visas
              )}
              {this.renderInput("name", "Name", "text")}
              {this.renderInput("mobile", "Mobile", "text")}
              {this.renderInput("ref_name", "Reference Name", "text")}
              {this.renderInput("ref_mobile", "Reference Mobile", "text")}
              {this.renderInput("cost", "Cost", "text")}
              {this.renderSelect(
                "expiry_duration_options",
                "Renewal Duration",
                this.state.expiry_duration_options
              )}
              <label> Renewal Date </label>
              <DatePicker
                selected={this.state.expiryDate}
                onChange={this.handleChangeExpiry}
                className="input"
              />
              {this.renderInput("emirates_id", "Emirates Id", "text")}

              {this.renderButton("Save")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default VehicleForm;
